import Styled from "./TertiaryButtonStyles";

import { FONT_FAMILY } from "../../ontego-ui";
import ArrowHeadSpecial from "../../Icons/ArrowHeadSpecial";
import { fontSizeTertiaryButtonIcon, iconSizeTertiaryButtonIcon } from "../../Utils/Utils";

const TertiaryButton = props => {
    const { id, style, size, theme, onClick, noIcon, isIconBeforeText = false, icon = (<ArrowHeadSpecial style={{ marginLeft: 8, width: iconSizeTertiaryButtonIcon(size), height: iconSizeTertiaryButtonIcon(size) }} />) } = props

    return (
        <Styled.ButtonContainer
            id={id}
            style={{
                fontFamily: FONT_FAMILY.PLUS_JAKARTA_SANS_SEMIBOLD,
                fontSize: fontSizeTertiaryButtonIcon(size),
                ...style
            }}
            onClick={onClick}
            buttontheme={theme}
        >
            {!noIcon && isIconBeforeText && (
                <Styled.ArrowContainer size={size} iconTheme={theme}>
                    {icon}
                </Styled.ArrowContainer>
            )}

            {props.children}

            {!noIcon && !isIconBeforeText && (
                <Styled.ArrowContainer size={size} iconTheme={theme}>
                    {icon}
                </Styled.ArrowContainer>
            )}

        </Styled.ButtonContainer>
    )
}

export default TertiaryButton